import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { AccountProvider } from './context/accounts/Account.context';
import { AuthProvider } from './context/authentication/Auth.context';
import { UserProvider } from './context/users/User.context';
import { FacebookPageProvider } from './context/facebookPages/FacebookPage.context';
import { VpsAlertProvider } from './context/vpsAlert/vpsAlert.context';
import LayoutProvider from './context/layouts/Layout.context';

import 'react-toastify/dist/ReactToastify.css';
import RequestAccountsProvider from './context/requests/RequestAccounts.context';
import MemberProvider from './context/members/Member.context';
import RequestPagesProvider from './context/requestPage/RequestPages.context';

ReactDOM.render(
  <AuthProvider>
    <LayoutProvider>
      <UserProvider>
        <AccountProvider>
          <FacebookPageProvider>
            <VpsAlertProvider>
              <RequestAccountsProvider>
                <RequestPagesProvider>
                  <MemberProvider>
                    <App />
                  </MemberProvider>
                </RequestPagesProvider>
              </RequestAccountsProvider>
            </VpsAlertProvider>
          </FacebookPageProvider>
        </AccountProvider>
      </UserProvider>
    </LayoutProvider>
  </AuthProvider>,
  document.getElementById('root')
);
